import script from "./secret.vue?vue&type=script&setup=true&lang=ts"
export * from "./secret.vue?vue&type=script&setup=true&lang=ts"

import "./secret.vue?vue&type=style&index=0&id=5e39d30c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e39d30c"]])

export default __exports__